module.exports = __webpack_public_path__ + "static/media/signup2.f9071a62.png";